import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { movieDetailsThunk } from "../../redux/details/details-thunk";
import { unwrapResult } from "@reduxjs/toolkit";
import "./MovieDetails.scss";

const MovieDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (id) {
      dispatch(movieDetailsThunk(id))
        .then(unwrapResult)
        .then((resultAction) => {
          const movieDetails = resultAction.payload;
        })
        .catch((errorAction) => {
          console.error('Erro ao buscar os detalhes do filme:', errorAction.error);
        });
    }
  }, [dispatch, id]);

  const movieDetails = useSelector((state: RootState) => state.movieDetails);

  if (movieDetails.status === "loading") {
    return <div className="loading">Carregando...</div>;
  }

  if (movieDetails.status === "failed") {
    return <div className="error">Erro ao buscar os detalhes do filme.</div>;
  }

  const { title, release_date, overview, poster_path } = movieDetails.value || {};
  const genres = movieDetails.value ? movieDetails.value.genres : [];

  const imageURL = "https://image.tmdb.org/t/p/w300/";
  return (
    <div className="details">
      <div className="box-content">
        <div className="principal-information">
          <img src={`${imageURL}${poster_path}`} alt="image backdrop" />
          <div className="information">
            <h2>{title}</h2>
            <div className="genre-box">
              {genres.map((genre) => (
                <span className="genre" key={genre.id}>{genre.name}</span>
              ))}
            </div>
          </div>
        </div>
        <p>{release_date}</p>
        <p>{overview}</p>
      </div>
    </div>
  );
};

export default MovieDetails;
